import React from "react";
import { Accordion, Button } from "react-bootstrap";
import useAdminData from '../hooks/useAdminData';
import { useNavigate } from 'react-router';

const TestimonialsAccordion = ({ testimonials }) => {
    const navigate = useNavigate();
    const { deleteTestimonial, error } = useAdminData();


    return (
        <Accordion flush className="my-3">
            {!error && testimonials.map((testimonial, index) => {
                return (
                    <Accordion.Item eventKey={index} key={`t-${index}`}>
                        <Accordion.Header>{testimonial.name}</Accordion.Header>
                        <Accordion.Body className="text-dark">
                            {testimonial.text}
                            <hr />
                            <Button className="me-3" size="sm" onClick={() => navigate(`/admin/testimonials/${testimonial._id}`, {index})}><i className="fas fa-edit"></i> Editar</Button>
                            <Button variant="danger" size="sm" onClick={() => deleteTestimonial(testimonial._id)}> <i className="fas fa-trash"></i> Apagar</Button>
                        </Accordion.Body>
                    </Accordion.Item>
                );
            })}
        </Accordion>
    );
};

export default TestimonialsAccordion;
